export default __webpack_public_path__ + "static/media/indie.8f1a2676.svg";